import { j as o } from "../../../../node_modules/react/jsx-runtime.js";
import { useState as R } from "react";
import B from "./Header.js";
import T from "./Days.js";
import { clsx as E } from "../../../../node_modules/clsx/dist/clsx.m.js";
import H from "./SelectedDates.js";
import { compareDatesByMonth as x, getStartDate as L, getEndDate as q, isTodayDisabled as w } from "../calender.helper.js";
import N from "./PresetRange.js";
import Y from "./Years.js";
import v from "../Calender.module.scss.js";
import A from "./Months.js";
import F from "./HeaderMonth.js";
const P = ({
  selectedDates: m,
  selectedMonth: d,
  currentMonth: a,
  minDate: r,
  maxDate: s,
  events: b,
  disabledDates: h,
  disableWeekends: y,
  onDateClick: i,
  setCurrentMonth: f,
  showMonthYearPicker: n = !1,
  size: p = "compact",
  type: t = "single",
  showPreSetRange: C,
  hasTimePicker: u,
  updateSelectedDates: S
}) => {
  var e;
  const [g, c] = R(!1), j = (e = document.querySelector("[class*=today]")) == null ? void 0 : e.firstChild;
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: E(v.calendar, {
        "border-0 border-r border-solid border-color-border-lightest": p === "extended" || u
      }),
      children: [
        n ? /* @__PURE__ */ o.jsx(
          F,
          {
            type: t,
            month: d,
            currentMonth: a,
            onChange: f,
            onClick: () => c(!g)
          }
        ) : /* @__PURE__ */ o.jsx(
          B,
          {
            type: t,
            month: x(d, r, s),
            currentMonth: x(a, r, s),
            onChange: f,
            onClick: () => c(!g)
          }
        ),
        p === "compact" && !n && /* @__PURE__ */ o.jsx(
          H,
          {
            type: t,
            size: p,
            showTodayButton: !0,
            starRangeDate: L(m),
            endRangeDate: q(m),
            disabledTodayButton: (j == null ? void 0 : j.disabled) || w(r, s, y),
            onChange: (l) => {
              i(l), f(l);
            }
          }
        ),
        C && S && /* @__PURE__ */ o.jsx(N, { onChange: S }),
        g ? /* @__PURE__ */ o.jsx(
          Y,
          {
            currentMonth: a,
            minDate: r,
            maxDate: s,
            onChange: (l) => {
              f(l), c(!1);
            }
          }
        ) : n ? /* @__PURE__ */ o.jsx(
          A,
          {
            selectedDates: m,
            selectedMonth: d,
            minDate: r,
            maxDate: s,
            events: b,
            disabledDates: h,
            onSelect: i
          }
        ) : /* @__PURE__ */ o.jsx(
          T,
          {
            selectedDates: m,
            selectedMonth: x(d, r, s),
            minDate: r,
            maxDate: s,
            events: b,
            disabledDates: h,
            disableWeekends: y,
            onSelect: i
          }
        )
      ]
    }
  );
};
export {
  P as default
};
//# sourceMappingURL=CalenderCell.js.map
